import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ScrollToTop from './components/UI/ScrollToTop/ScrollToTop';
import SplashScreen from './components/SplachScreen/SplashScreen';

const app = (
  <Fragment>
    <SplashScreen wait={3000} />
    <HashRouter basename="/">
      <ScrollToTop>
        <App />
      </ScrollToTop>
    </HashRouter>
  </Fragment>
);

ReactDOM.render(app, document.getElementById('root'));

serviceWorker.unregister();
